export const PerpetualProtocolReferrerABI = [
    "function getReferralCodeByPartnerAddress(address partnerAddress) external view returns (string memory)",
    "function getRefereeCodeByTraderAddress(address traderAddress) public view returns (string memory)",
    "function createReferralCode(string calldata referralCode) public",
    "function setReferralCode(string calldata referralCode) public",
]
